<template>
  <v-card class="pa-4 ticket-container" elevation="0">
    <div class="d-flex align-center mb-4">
      <div class="ticket-number">{{ index + 1 }}</div>
      <div class="ticket-title">
        {{ ticket.nome_produto }} - {{ ticket.tipo }}
      </div>
    </div>
    <div>
      <nomination-form
        v-for="field in ticket.dados_extras"
        :key="field.codigo"
        :option="field"
        @save="$emit('save')"
        class="mb-1"
      />
    </div>
  </v-card>
</template>

<script>
import NominationForm from './NominationForm.vue';
export default {
  components: { NominationForm },
  props: ['ticket', 'index'],
};
</script>

<style></style>
